import { createSlice } from "@reduxjs/toolkit";
import { fetchReqRes } from "../api";
import { ReqResInfoVM } from "../../autogenerated/models";

export interface ReqResState {
  isLoading: boolean;
  data: ReqResInfoVM;
}

const initialState: ReqResState = {
  isLoading: false,
  data: {},
};

export const reqResSlice = createSlice({
  name: "reqRes",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setReqRes: (state, action) => {
      state.data = action.payload;
    },
    // setPage: (state, action) => {
    //   state.page = action.payload;
    // },
    // setUsers: (state, action) => {
    //   state.users = action.payload;
    // },
    // setUserRoles: (state, action: PayloadAction<UserDto>) => {
    //   let index = state.users.findIndex((u) => u.id === action.payload.id);
    //   if (index !== -1) state.users[index].roles = action.payload.roles;
    // },
    // setRoles: (state, action) => {
    //   state.roles = action.payload;
    // },
  },
});

export const { actions } = reqResSlice;

export const getReqRes = (sessionId: string) => (dispatch: any) => {
  dispatch(actions.setIsLoading(true));

  return fetchReqRes(sessionId)
    .then((data) => {
      if (data) dispatch(actions.setReqRes(data));
    })
    .finally(() => dispatch(actions.setIsLoading(false)));
};
